import {Injectable, Injector} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@environments/environment';
import {LanguageService} from '@core/services/language.service';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!this._isUmpireAuthUrl(request)) {
      return next.handle(request);
    }
    try {
      const languageService = this.injector.get(LanguageService);
      const clonedRequest = request.clone({
        headers: request.headers.append(
          'Accept-Language',
          languageService.currentLanguage$.getValue(),
        ),
      });

      return next.handle(clonedRequest);
    } catch {
      return next.handle(request);
    }
  }

  private _isUmpireAuthUrl(req: HttpRequest<unknown>): boolean {
    return req.url.includes(environment.clientConfig.apiUrls.umpire);
  }
}
